import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import { IFilterAllData, ListOfKeysFilterAllData } from 'src/typings/filter';
import { useFavoriteListState } from 'src/hooks';
import Box from '@mui/material/Box';
import { SvgWrapper } from 'src/components/SvgWrapper';
import { ReactComponent as ApartmentHeart } from 'src/assets/icon_apartment_heart.svg';
import { ReactComponent as ApartmentPDF } from 'src/assets/icon_apartment_pdf.svg';
import cx from 'classnames';
import CircularProgress from '@mui/material/CircularProgress';
import { Theme } from '@mui/material';
import { useTheme } from '@mui/styles';
import { useCreatePdf } from 'src/components/ApartmentPageV2/TabComponent/components/useCreatePdf';
import { useSelector } from 'react-redux';
import { getComplexId, getCurrentLang } from 'src/store/app/selectors';
import { getMappedPDFPaymentPlansRequest } from 'src/api/paymentPlan';
import { PDFDownload } from 'src/components/modals/PDFDownload';
import {
  ApartmentSidebarHistory,
} from 'src/components/CrosstableContent/components/AppartmentSidebarCross/components/ApartmentSidebarHistory';
import { useComplex } from 'src/hooks/app/use-complex';
import { useStyles } from './styles';

interface Props {
  placement: IFilterAllData;
}
export const ApartmentSidebarActions: React.FC<Props> = ({ placement }) => {
  const { complex } = useComplex();
  const theme: Theme = useTheme();
  const currentLang = useSelector(getCurrentLang);
  const {
    loading, handlerIcon, setOpenPDFPaymentPlansModal, openPDFPaymentPlansModal,
    setSelectedPDFPaymentPlan, selectedPDFPaymentPlan,
  } = useCreatePdf();
  const {
    isActive,
    toggleFavoriteItem,
  } = useFavoriteListState(placement[ListOfKeysFilterAllData.id]);
  const [mappedPDFPaymentPlans, setMappedPDFPaymentPlans] = useState([]);
  const [isHistoryOpen, setIsHistoryOpen] = useState<boolean>(false);
  const styles = useStyles();
  // The component unmounts easily mid-flight (unit switch swaps the sidebar to
  // a skeleton, popover closes) — never setState after that.
  const mountedRef = useRef(true);
  useEffect(() => () => {
    mountedRef.current = false;
  }, []);

  useEffect(() => {
    if (!loading) {
      setSelectedPDFPaymentPlan(null);
    }
  }, [loading]);

  useEffect(() => {
    if (selectedPDFPaymentPlan && complex) {
      handlerIcon(
        placement,
        complex,
        complex.title[currentLang],
        currentLang,
        selectedPDFPaymentPlan,
      );
    }
  }, [selectedPDFPaymentPlan, complex, currentLang]);

  const pdfHandler = async () => {
    if (complex) {
      const plans = await getMappedPDFPaymentPlansRequest(placement.id, currentLang, 'module');
      if (!mountedRef.current) return;
      setMappedPDFPaymentPlans(plans.data);
      handlerIcon(
        placement,
        complex,
        complex.title[currentLang],
        currentLang,
        undefined,
        (value) => {
          setOpenPDFPaymentPlansModal(value);
        },
      ).then();
    }
  };

  const onClickHistory = useCallback(() => {
    setIsHistoryOpen(true);
  }, []);

  return (
    <div className={styles.actionsWrapper}>
      {/* <Box className={styles.action} onClick={onClickHistory}> */}
      {/*  <SvgWrapper size={24}> */}
      {/*    <ApartmentClock className="clock" /> */}
      {/*  </SvgWrapper> */}
      {/* </Box> */}
      <Box className={styles.action} onClick={toggleFavoriteItem}>
        <SvgWrapper size={24}>
          <ApartmentHeart className={cx('heard', isActive && 'active')} />
        </SvgWrapper>
      </Box>
      <Box className={styles.action} onClick={pdfHandler}>
        <SvgWrapper size={24}>
          {loading ? (
            <CircularProgress size={14} sx={{ color: theme.palette.grey['400'] }} />
          ) : (
            <ApartmentPDF className={cx('pdf', isActive && 'active')} />
          )}
        </SvgWrapper>
      </Box>
      {/* Mount-gated: on mount the history modal writes its MOCK rows/columns
          into the SHARED useTable redux state and clobbers the list-view table.
          Keep it unmounted until actually opened (the trigger icon is disabled
          pending design anyway). */}
      {complex && isHistoryOpen && (
        <ApartmentSidebarHistory
          currentLang={currentLang}
          placement={placement}
          isOpen={isHistoryOpen}
          onClose={() => setIsHistoryOpen(false)}
        />
      )}
      {mappedPDFPaymentPlans && (
        <PDFDownload
          open={openPDFPaymentPlansModal}
          onClose={() => setOpenPDFPaymentPlansModal(false)}
          isLoading={selectedPDFPaymentPlan !== null}
          plansList={mappedPDFPaymentPlans}
          onSelectPlan={setSelectedPDFPaymentPlan}
        />
      ) }
    </div>
  );
};
